import axios from 'axios';

export const getMyBadges = (callback, errorcallback, params = {}) => {
  axios
    .get('/badges/get_my_badges', {
      params,
    })
    .then((response) => {
      if (response.status === 200) {
        callback(response.data);
      }
    })
    .catch((err) => {
      errorcallback(err);
    });
};

export const getBadgesByContactId = (contact_id, callback, errorcallback) => {
  axios
    .get(`/badges/get_by_contact_id?contact_id=${contact_id}`)
    .then((response) => {
      if (response.status === 200) {
        callback(response.data);
      }
    })
    .catch((err) => {
      errorcallback(err);
    });
};

export function createBadge(badge, callback, errorCallback) {
  axios
    .post('/badges/add', badge)
    .then((res) => {
      callback(res.data);
    })
    .catch((error) => {
      errorCallback(error);
    });
}

export function updateBadge(badge, callback, errorCallback) {
  axios
    .post('/badges/update', badge)
    .then((res) => {
      callback(res.data);
    })
    .catch((error) => {
      errorCallback(error);
    });
}

export function deleteBadge(id, callback, errorCallback) {
  axios
    .post('/badges/delete', { id })
    .then((res) => {
      callback(res.data);
    })
    .catch((error) => {
      errorCallback(error);
    });
}
